'use strict';

module.exports = require('./slider');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.0.14.7@react-slick/lib/index.js
 ** module id = 318
 ** module chunks = 0 1
 **/